import { FunctionComponent, SVGProps } from 'react'

import { ExclamationPointIcon } from '@nx/fire/assets'

import {
  StyledBody,
  StyledInfoContainer,
  StyledInfoIcon,
} from './InfoBox.styles'

export function FireInfoBox({
  level = 'INFO',
  icon = ExclamationPointIcon,
  children,
}: FireInfoBoxProps) {
  return (
    <StyledInfoContainer $level={level}>
      <StyledInfoIcon $level={level} as={icon} />
      <StyledBody>{children}</StyledBody>
    </StyledInfoContainer>
  )
}

export type FireInfoBoxProps = React.PropsWithChildren<{
  level?: 'INFO' | 'ERROR'
  icon?: FunctionComponent<
    SVGProps<SVGSVGElement> & {
      title?: string
    }
  >
}>
